import { Reason } from './types';

export const REASONS = {
    Consultation: 'для проведения консультации',
    Deposit: 'для проведения пополнения',
    Registration: 'для оформления полиса',
} as const;

export const BUTTON_COLOURS: Record<Reason, string> = {
    Consultation: 'linear-gradient(45deg, #15B015FF 0%, #04C6C9FF 100%)',
    Deposit: '#333f48',
    Registration: 'linear-gradient(45deg, #15B015FF 0%, #04C6C9FF 100%)',
} as const;

export const BUTTON_VIEWS: Record<Reason, 'accent-gradient' | 'dark'> = {
    Consultation: 'accent-gradient',
    Deposit: 'dark',
    Registration: 'accent-gradient',
} as const;
